var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleWeeklyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 8,
    height: 8,
    rx: 4,
    fill: "#e1af00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleWeeklyIcon);
export default __webpack_public_path__ + "static/media/schedule-weekly-icon.766bd782214cb33f47fa5c67529f8a8a.svg";
export { ForwardRef as ReactComponent };